import styled from 'styled-components';

export const ExitWrapper = styled.div`
    position: absolute;
    top: 25px;
    left: 35px;
    transform: scaleX(-1);
`